import { ErrorHandler, Injectable } from "@angular/core";

@Injectable()
export class AppErrorHandlerService implements ErrorHandler {
  handleError(error: any): void {
    console.error("Application error:", error);
  }
}
